<template>
  <div class="page">
    <div class="banner">
      <img src="../assets/images/craftBanner.png" alt="" />
    </div>
    <nav>
      <ul>
        <li>
          <img src="../assets/images/craftIcon1.png" alt="" />
          <p>海派精工施工工艺</p>
          <div></div>
          <span>精雕细琢匠心工艺</span>
        </li>
        <li>
          <img src="../assets/images/craftIcon2.png" alt="" />
          <p>6大施工坚持</p>
          <div></div>
          <span>用品质打造匠心榜样</span>
        </li>
        <li>
          <img src="../assets/images/craftIcon3.png" alt="" />
          <p>直有工人施工不外包</p>
          <div></div>
          <span>匠心造匠品全部持证上岗</span>
        </li>
      </ul>
    </nav>
    <div class="standard">
      <div class="standard_">
        <div class="craftTitle">
          <p>严苛标准 用专业树立行业标杆</p>
          <div></div>
          <span>精良工艺体现在家的每个细微之处</span>
        </div>
        <ul>
          <li
            v-for="(item, index) in standardTitle"
            :key="item"
            @click="choose(item, index)"
            :class="{ standardActive: categoryIndex == index }"
          >
            {{ item }}
          </li>
        </ul>
        <van-swipe
          @change="onChange"
          :autoplay="3000"
          :show-indicators="false"
          lazy-render
          ref="swipe"
        >
          <van-swipe-item class="banner_list">
            <img src="../assets/images/circuit.png" alt />
          </van-swipe-item>
          <van-swipe-item class="banner_list">
            <img src="../assets/images/watertight.png" alt />
          </van-swipe-item>
          <van-swipe-item class="banner_list">
            <img src="../assets/images/wall.png" alt />
          </van-swipe-item>
          <van-swipe-item class="banner_list">
            <img src="../assets/images/floor.png" alt />
          </van-swipe-item>
        </van-swipe>
      </div>
    </div>
    <div class="technology">
      <div class="technology_">
        <div class="craftTitle">
          <p style="color: #000">8大特色施工工艺</p>
          <div style="background-color: #000"></div>
          <span style="color: #000">持续的品质升级，给家过硬的专业水准</span>
        </div>

        <ul>
          <li v-for="(item, index) in technology" :key="index">
            <div @click="changeIndex(item,index)">
              <p>{{ item.number }}</p>
              <span>{{ item.title }}</span>
            </div>
                   <img :src="item.image" :class="tecIdex==index?'tecACT':'tecEnd'"  alt="" />
       
          </li>
        </ul>
      </div>
    </div>
    <div class="persist">
      <div class="persist_">
        <div class="craftTitle">
          <p>怎么装6大坚持</p>
          <div></div>
          <span>深入上海每一户家庭 解决因环境带来的居住困扰</span>
        </div>
        <ul class="technologyContent">
          <li v-for="(item, index) in persistImg" :key="index"
          :class="perIdex==index?'tecImgAct':'tecImgEnd'">
            <p>{{ item.title }}</p>
            <span>{{ item.detail }}</span>
            <img :src="item.img"  alt="" />
          </li>
        </ul>
        <ul class="technologyBottom">
          <li v-for="(item, index) in persistLogo" :key="index"
           @click="bigger(item,index)" :class="perIdex==index?'perAct':'perEnd'"
          >
            <img :src="item" alt=""  />
          </li>
        </ul>
      </div>
    </div>
    <div class="worker">
      <div class="worker_">
        <div class="craftTitle">
          <p style="color: #000">直有工人 施工团队定期培训</p>
          <div style="background-color: #000"></div>
          <span style="color: #000">有标准还需好工人 匠心造匠品</span>
        </div>

        <van-swipe :autoplay="3000" :show-indicators="false" lazy-render>
          <van-swipe-item
            v-for="(item, index) in worker"
            :key="index"
            class="banner_list"
          >
            <img :src="item" alt />
          </van-swipe-item>
        </van-swipe>
        <div class="workerDetail">
          <ul>
            <li>
              <div>有技术</div>
              <p>均<span>12</span>年+行业经验 专业过硬</p>
            </li>
            <li>
              <div>有规则</div>
              <p>严格考核入选 统一培训管理</p>
            </li>
            <li>
              <div>有口碑</div>
              <p>施工交付 满意度平均 <span>9.6</span>分</p>
            </li>
            <li>
              <div>有保障</div>
              <p>直有工人 集团直管</p>
            </li>
          </ul>
          <a href="javascript:;" @click="$router.push('/baojia')">预约五星工长</a>
        </div>
      </div>
    </div>
    <div class="aptitude">
      <div class="aptitude_">
        <div class="craftTitle">
          <p>怎么装权威资质认证</p>
          <div></div>
          <span>权威认证 品质保障</span>
        </div>
        <img src="../assets/images/certificate.png" alt="" />
        <div class="star">上海市室内装饰行业协会一级专业能力评价</div>
        <button @click="$router.push('/baojia')">预约品质装修服务</button>
        <div class="privacy">
          *确保您的隐私与我们的声誉，您的信息将被严格保密。
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {
   tecIdex:0,
   perIdex:0,
      standardTitle: ["电路", "防水", "墙面", "地面"],
      categoryIndex: 0,
      technology: [
        {
          number: "1",
          title: "防水团队",
          image: require("../assets/images/technologyImg1.png"),
        },
        {
          number: "2",
          title: "轻钢龙骨",
          image: require("../assets/images/technologyImg8.png"),
        },
        {
          number: "3",
          title: "过门梁",
          image: require("../assets/images/technologyImg7.png"),
        },
        {
          number: "4",
          title: "湿区门套",
          image: require("../assets/images/technologyImg2.png"),
        },
        {
          number: "5",
          title: "淋欲区",
          image: require("../assets/images/technologyImg3.png"),
        },
        {
          number: "6",
          title: "隔音棉包管",
          image: require("../assets/images/technologyImg4.png"),
        },
        {
          number: "7",
          title: "强弱电",
          image: require("../assets/images/technologyImg5.png"),
        },
        {
          number: "8",
          title: "接线端子",
          image: require("../assets/images/technologyImg6.png"),
        },
      ],
      persistImg: [
        {
          title: "/ 坚持选用轻钢龙骨 /",
          detail:
            "轻钢龙骨是一种轻质材料，具有优良的防火性能 ；采用装配式的施工方法，施工效率高，结构安全可靠强度较高，刚度较大；抗冲击性能好，纵向断裂荷载为390～850N；抗震性能良好可提高隔热、隔声效果及室内利用率.",
          img: require("../assets/images/persistImg1.png"),
        },

        {
          title: "/ 坚持选用防霉防潮涂料 /",
          detail:
            "直接滚涂在霉菌上可以迅速杀死现有霉菌，包含抗菌剂可以抑制霉菌、真菌生长。可以涂刷在墙壁、砖石、木材和金属等上，遮盖微生物和真菌斑点。室内/室外、地面通用，水性无毒，超低气味、超低OC。",
          img: require("../assets/images/persistImg3.png"),
        },
        {
          title: "/ 坚持选用防水专业团队 /",
          detail:
            "俞润与咖乐深度合作，采用厂家直营工人上门服务，确保技术与质量最优。涂刷第二遍防水，等待确定第一遍防水完全干透成膜后再进行，防水效果才最佳。俞润防水会进行闭水试验，正常的闭水高度为3-5mm，闭水时间为24h-48h，现观察有无渗漏现象。 ",
          img: require("../assets/images/persistImg4.png"),
        },
        {
          title: "/ 坚持使用六道线标准 /",
          detail:
            "专业的找平团队，对于三种找平方法都能熟练运营，自流平找平法，水泥砂浆找平法、石膏线找平法、不同的空间情况对应不一样的找平方式。确保地面平整度达标，通过数据测量来调整以达到参数标准。",
          img: require("../assets/images/persistImg5.png"),
        },
        {
          title: "/ 坚持选用专业找平团队 /",
          detail:
            "专业的找平团队，对于三种找平方法都能熟练运营，自流平找平法，水泥砂浆找平法、石膏线找平法、不同的空间情况对应不一样的找平方式。确保地面平整度达标，通过数据测量来调整以达到参数标准。",
          img: require("../assets/images/persistImg2.png"),
        },
        {
          title: "/ 坚持无图不设计无图不施工 /",
          detail:
            "拥有100+设计师团队、专门的设备上门量房，通过数据精确的画出平面户型图，再根据平面户型图帮您设计效果图，呈现您心中理想新家的模样，施工团队严格按照施工图标准执行，确保1:1还原您梦想的家。 ",
          img: require("../assets/images/persistImg6.png"),
        },
      ],
      persistLogo: [
        require("../assets/images/persistLogo1.png"),
        require("../assets/images/persistLogo2.png"),
        require("../assets/images/persistLogo3.png"),
        require("../assets/images/persistLogo4.png"),
        require("../assets/images/persistLogo5.png"),
        require("../assets/images/persistLogo6.png"),
      ],
      worker: [
        require("../assets/images/workImg1.png"),
        require("../assets/images/workImg2.png"),
        require("../assets/images/workImg3.png"),
        require("../assets/images/workImg4.png"),
      ],
    };
  },
  methods: {
    choose(item, index) {
      this.categoryIndex = index;
      this.$refs.swipe.swipeTo(index);
    },
    onChange(index) {
      this.categoryIndex = index;
    },

    changeIndex(item,index){
      console.log(index);
      this.tecIdex=index
    },
    bigger(item,index){
      console.log(index);
        this.perIdex=index
    }
  },
  components: {},
};
</script>

<style scoped lang="scss">
.page {
  background-color: #fff;
}
* {
  box-sizing: border-box;
}
.craftTitle {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  p {
    font-size: 20px;
    font-family: "FZLanTingHeiS-B-GB";
    font-weight: 400;
    color: #ffffff;
  }
  div {
    width: 38px;
    height: 2px;
    background: #ffffff;
    margin: 8px 0px;
  }
  span {
    font-size: 11px;
    font-weight: 400;
    color: #ffffff;
  }
}
.banner {
  width: 100%;
  img {
    width: 100%;
  }
}
nav {
  width: 100%;
  padding: 31px 13px 33px 18px;
  box-sizing: border-box;
  background-color: #fff;
  ul {
    width: 100%;
    display: flex;
    justify-content: space-between;
    li {
      display: flex;
      flex-direction: column;
      align-items: center;
      img {
        width: 51px;
        margin-bottom: 6px;
      }
      p {
        font-size: 11px;
        font-family: FZLanTingHeiS-B-GB;
        font-weight: 400;
        color: #333333;
        margin-bottom: 6px;
      }
      div {
        width: 12px;
        height: 1px;
        background: #fade4b;
        margin-bottom: 4px;
      }
      span {
        font-size: 7px;
        font-family: FZLanTingHei-R-GBK;
        font-weight: 400;
        color: #333333;
      }
    }
  }
}
.standard {
  width: 100%;
  background: url("../assets/images/standard.png");
  background-size: cover;
  .standard_ {
    width: 100%;
    padding: 42px 15px 45px;
  }
  ul {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-top: 25px;
    margin-bottom: 9px;
    li {
      width: 70px;
      height: 34px;
      background: #ffffff;
      border-radius: 5px;
      font-size: 14px;
      font-weight: 400;
      color: #040608;
      display: grid;
      place-items: center;
    }
    .standardActive {
      background-color: #fade4b;
    }
  }
  .van-swipe {
    width: 100%;
    .van-swipe-item {
      width: 100%;
      img {
        width: 100%;
      }
    }
  }
}
.technology {
  width: 100%;
  background: url("../assets/images/characteristic.png") no-repeat;
  background-size: cover;
  .technology_ {
    width: 100%;
    padding: 30px 13px 50px 16px;
    ul {
      width: 100%;
      margin-top: 24px;
      li {
        width: 100%;
        overflow: hidden;
        &:nth-child(2n + 1) > div {
          background-color: #fade4b;
        }
        // &:nth-child(n + 2) > img {
        //   display: none;
        // }
        div {
          width: 100%;
          padding: 0px 30px 0px 38px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 31px;
          background: #b7b7b7;
          p {
            font-size: 18px;
            font-family: FZLanTingHeiS-R-GB;
            font-weight: 400;
            color: #000000;
          }
          span {
            width: 80px;
            font-size: 16px;
            font-family: FZLanTingHeiS-R-GB;
            font-weight: 400;
            color: #000000;
          }
        }
        img {
          width: 100%;
          float: left;
           transition: all 0.5s;
        }
      }
    }
  }
}
.persist {
  width: 100%;
  background: url("../assets/images/sxiPersist.png");
  background-size: cover;
  .persist_ {
    width: 100%;
    padding: 35px 12px 36px 15px;
    .technologyContent {
      width: 100%;
      margin-top: 31px;
      margin-bottom: 11px;
      li {
        width: 100%;
        padding: 32px 45px 25px 24px;
        background-color: #fff;
        // &:nth-child(n + 2) {
        //   display: none;
        // }
        p {
          font-size: 17px;
          font-family: FZLanTingHeiS-B-GB;
          font-weight: 400;
          color: #222222;
        }
        span {
          display: block;
          font-size: 8px;
          font-family: FZLanTingHei-R-GBK;
          font-weight: 400;
          color: #222222;
          line-height: 1.5;
          margin-top: 17px;
          margin-bottom: 24px;
        }
        img {
          width: 100%;
        }
      }
    }
    .technologyBottom {
      width: 100%;
      height: 106px;
      background-color: rgba($color: #000000, $alpha: 0.5);
      display: flex;
      justify-content: space-between;
      align-items: center;
      li {
        width: 45px;
        height: 45px;
        background-color: #000000;
        // opacity: .7;
        img {
          width: 100%;
        }
      }
    }
  }
}

.worker {
  width: 100%;
  background: url("../assets/images/worker.png");
  background-size: cover;
  .worker_ {
    width: 100%;
    padding: 52px 13px 47px 12px;
    .van-swipe {
      width: 100%;
      margin-top: 24px;
      img {
        width: 100%;
        float: left;
      }
    }
    .workerDetail {
      width: 100%;
      background: #454545;
      padding-bottom: 18px;
      // background-size: cover;
      ul {
        width: 100%;
        padding: 11px 20px 0px 0px;
        li {
          display: flex;
          align-items: center;
          // justify-content: center;
          margin-bottom: 25px;
          padding-left: 20px;
          div {
            font-size: 20px;
            font-family: FZLanTingHei-R-GBK;
            font-weight: 400;
            color: #ffffff;
            margin-right: 23px;
          }
          p {
            font-size: 12px;
            font-family: FZLanTingHei-R-GBK;
            font-weight: 400;
            color: #ffffff;
            span {
              font-size: 22px;
              font-family: FZLanTingHei-R-GBK;
              font-weight: 400;
              color: #ffffff;
            }
          }
        }
      }
      a {
        margin: 0 auto;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 263px;
        height: 27px;
        background: #fade4b;
        border-radius: 12px;
        font-size: 15px;
        font-family: FZLanTingHei-R-GBK;
        font-weight: 400;
        color: #000000;
      }
    }
  }
}
.aptitude {
  width: 100%;
  background: url("../assets/images/aptitude.png");
  background-size: cover;
  .aptitude_ {
    width: 100%;
    padding: 33px 35px 35px 38px;
    img {
      width: 100%;
      margin-top: 31px;
      margin-bottom: 10px;
    }
    .star {
      width: 100%;
      display: flex;
      justify-content: center;
      font-size: 8px;
      font-family: FZLanTingHei-R-GBK;
      font-weight: 400;
      color: #ffffff;
      margin-bottom: 35px;
    }
    button {
      width: 100%;
      height: 34px;
      background: #ffe100;
      border-radius: 2px 2px 2px 2px;
      margin-bottom: 7px;
    }
    .privacy {
      width: 100%;
      text-align: center;
      font-size: 8px;
      font-family: FZLanTingHei-EL-GBK;
      font-weight: 400;
      color: #ffffff;
    }
  }
}
  
 .tecACT{
   width: 100% !important;
   transition: all 1s;
 }
 .tecEnd{
   width: 0px !important;
   transition: all 1.5s;

 }
  .perAct{
    width: 51px !important;
    opacity: 1 !important;
   transition: all 1s;

  }
  .perEnd{
    width: 45px !important;
    opacity: .7 !important;
   transition: all 1s;

  }
 
 .tecImgAct{
  display: block;
   transition: all 1s;
 }
 .tecImgEnd{
   display: none;
  transition: all 1s;
 }
</style>
